module.exports = __webpack_public_path__ + "static/media/close-circle_red.489191d1.svg";